/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capacityoptional1Inputs */

const en_capacityoptional1 = /** @type {(inputs: Capacityoptional1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacity (Optional)`)
};

const de_capacityoptional1 = /** @type {(inputs: Capacityoptional1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapazität (optional)`)
};

/**
* | output |
* | --- |
* | "Capacity (Optional)" |
*
* @param {Capacityoptional1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const capacityoptional1 = /** @type {((inputs?: Capacityoptional1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capacityoptional1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capacityoptional1(inputs)
	return de_capacityoptional1(inputs)
});
export { capacityoptional1 as "capacityOptional" }